"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const map_status_to_value_1 = require("../map-status-to-value");
const match_status_1 = require("../match-status");
class MapperBuilder {
    constructor() {
        this.translations = {};
        this.statusList = {};
        this.assertions = {};
        this.statusesKeys = [];
        this.statusesValues = [];
        this.checklist = {
            status: false,
            translation: false,
            assert: false,
        };
    }
    toMapperInterface() {
        this.isMapperReady();
        return {
            status: this.statusList,
            statusKeys: this.statusesKeys,
            statusValues: this.statusesValues,
            translate: this.translate.bind(this),
            assertStatus: this.assertions,
            isOneOf: this.isOneOf.bind(this),
        };
    }
    markItemAsFilled(key) {
        this.checklist[key] = true;
    }
    setStatus(list) {
        this.statusList = list;
        this.statusesKeys = Object.keys(this.statusList);
        this.statusesValues = Object.values(this.statusList);
        this.markItemAsFilled('status');
        return this;
    }
    setTranslations(translations) {
        this.translations = translations;
        this.markItemAsFilled('translation');
        return this;
    }
    setAssertions(assertions) {
        this.assertions = assertions;
        this.markItemAsFilled('assert');
        return this;
    }
    isOneOf(statuses) {
        const hasMatch = statuses.find((status) => {
            return this.statusesValues.indexOf(status) !== -1;
        });
        return !!hasMatch;
    }
    translate(status) {
        return map_status_to_value_1.default(status, this.translations);
    }
    buildAssertFunc(matchTo) {
        return (status) => match_status_1.default(status, matchTo);
    }
    isFilled() {
        return Object.values(this.checklist).every((value) => value);
    }
    isMapperReady() {
        if (!this.isFilled()) {
            const keys = Object.entries(this.checklist)
                .filter(([key, value]) => value)
                .map(([key, value]) => key);
            throw new Error('Missing fields: ' + keys.join(', '));
        }
    }
}
exports.default = MapperBuilder;
//# sourceMappingURL=MapperBuilder.js.map